import React from 'react'

import styled from 'styled-components'

const Dropdown = ({ list, title }) => {
  const [listOpen, setListOpen] = React.useState(false)
  const toggleList = () => {
    setListOpen(!listOpen)
  }
  const closeList = () => {
    setListOpen(false)
    window.removeEventListener('click', closeList)
  }
  React.useEffect(() => {
    if (listOpen) {
      window.addEventListener('click', closeList)
    }
    return () => window.removeEventListener('click', closeList)
  }, [listOpen])
  return (
    <Wrapper onClick={toggleList} on>
      <Header>
        <HeaderTitle>{title}</HeaderTitle>
        {listOpen ? (
          <i className='material-icons' style={{ color: 'white' }}>
            arrow_drop_up
          </i>
        ) : (
          <i className='material-icons' style={{ color: 'white' }}>
            arrow_drop_down
          </i>
        )}
      </Header>
      {listOpen && (
        <List onClick={(e) => e.stopPropagation()}>
          {list.map((item, i) => (
            <ListItem key={`${i}-dropdown-item`} onClick={item.onClick}>
              {item.title}
            </ListItem>
          ))}
        </List>
      )}
    </Wrapper>
  )
}

const HeaderTitle = styled.p`
  margin: 0px;
  text-transform: uppercase;
  line-height: 17px;
  margin: 0;
  font-size: 13px;
  text-align: center;
  color: white;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: default;
  position: relative;
  height: 17px;
  cursor: pointer;
`

const List = styled.ul`
  margin: 8px 0;
  border-radius: 4px;
  z-index: 10;
  position: absolute;
  left: 0px;
  border: 1px solid #dfdfdf;
  background-color: #fff;
  padding: 14px 0px;
  overflow-y: scroll;
  min-width: 110px;
  display: flex;
  flex-direction: column;
  width: 100%;
`

const ListItem = styled.li`
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
  padding: 10px 17px;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: transparent;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  &:hover {
    transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    background-color: rgba(0, 0, 0, 0.08);
  }
`

const Wrapper = styled.div`
  z-index: 999;
  background-color: transparent;
  position: relative;
  cursor: pointer;
`

export default Dropdown
